import { Component, OnInit, Input } from '@angular/core';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { UserOptions } from 'jspdf-autotable';
import { DATA } from './data';
import '../../../../assets/fonts/Cairo-VariableFont_slnt,wght-normal';
// import './Cairo-VariableFont_slnt,wght-normal';


interface jsPDFWithPlugin extends jsPDF {
  autoTable: (options: UserOptions) => jsPDF;
  lastAutoTable: any;
}

@Component({
  selector: 'app-generate-pdf',
  templateUrl: './generate-pdf.component.html',
  styleUrls: ['./generate-pdf.component.css']
})
export class GeneratePdfComponent {

  @Input() actionPlan: any;
  @Input() actionItemsList: any;
  DOC: any;
  PAGE_MIDDLE_X: any;
  pageY: any;
  SPACER_Y: any;
  LINE_GAP_Y: any;
  MARGIN_TOP: any;
  MARGIN_BOTTOM: any;
  data = DATA;
  fileName = "Action Plan";
  disclaimerText = "** Disclaimer – This document is strictly confidential and solely for the use of the recipient entity and may not be reproduced or circulated without Ministry of Economy’s prior written consent. If you are not a recipient, you may not disclose or use the information in this documentation in any way."
  DATA_COLUMN_WIDTH: any;
  HEADER_COLUMN_WIDTH: any;


  generatePdf() {
    const actionPlanTable: any = document.getElementById('actionPlanRef');
    const allActionItemTables = document.getElementById('actionItemTablesContainerRef')?.querySelectorAll('table');

    this.initializePdf();
    this.generatePageHeader(); 
    this.pageY = this.pageY + this.SPACER_Y;
    this.generateActionPlanHeader();
    this.pageY = this.pageY + this.SPACER_Y;
    this.generateTable(actionPlanTable);
    this.pageY = this.pageY + this.SPACER_Y;
    this.generateActionItemsHeader();
    this.pageY = this.pageY + this.SPACER_Y;
    allActionItemTables?.forEach((table: any) => {
    this.generateTable(table);
    })

    this.savePdf();
  }

  initializePdf() {
    this.DOC = new jsPDF('l', 'pt', 'a4') as jsPDFWithPlugin;
    this.DOC.setFont('Cairo-VariableFont_slnt,wght');
    this.SPACER_Y = 20;
    this.pageY = this.SPACER_Y;
    this.LINE_GAP_Y = 5;
    this.PAGE_MIDDLE_X = this.DOC.internal.pageSize.getWidth() / 2;
    this.HEADER_COLUMN_WIDTH = this.DOC.internal.pageSize.getWidth() / 5;
    this.DATA_COLUMN_WIDTH = this.DOC.internal.pageSize.getWidth() / 4;
    this.MARGIN_TOP = this.SPACER_Y * 5;
    this.MARGIN_BOTTOM = this.SPACER_Y * 4;
  }

  savePdf() {
    this.fileName = this.actionPlan?.actionId ? this.actionPlan?.actionId : "Action Plan";
    this.DOC.save(this.fileName);
  }

  generatePageHeader() {
    this.DOC.setLineWidth(2);
    const IMAGE_RESOLUTION_WIDTH = 150;
    const ADJUST = 0;
    var img = new Image();
    img.src = '../../../../assets/images/DIEZ_logo.png';
    this.DOC.addImage(img, 'png', this.PAGE_MIDDLE_X - IMAGE_RESOLUTION_WIDTH / 2 + ADJUST, this.SPACER_Y , 150 , 71 );
  }

  generatePageFooter() {
    this.DOC.setTextColor(115, 115, 115);
    this.DOC.setFontSize(9);
    let splitTitle = this.DOC.splitTextToSize(this.disclaimerText, this.DOC.internal.pageSize.width - 80);
    this.DOC.text(splitTitle, 40, this.DOC.internal.pageSize.height - 50);
  }

  generateActionPlanHeader() {
    this.pageY = this.pageY + this.SPACER_Y * 3.5;
    this.DOC.setTextColor(0, 0, 0);
    const actionPlanText = 'Assessment Action Plan';
    const actionPlanTextWidth = this.DOC.getTextWidth(actionPlanText);
    this.DOC.text(actionPlanText, this.PAGE_MIDDLE_X, this.pageY, { align: 'center' });
    this.DOC.setDrawColor(0, 0, 0);
    this.pageY = this.pageY + this.LINE_GAP_Y;
    this.DOC.line(this.PAGE_MIDDLE_X - actionPlanTextWidth / 2, this.pageY, this.PAGE_MIDDLE_X + actionPlanTextWidth / 2, this.pageY);
  }

  generateActionItemsHeader() {
    this.DOC.setTextColor(0, 0, 0);
    const actionItemText = 'Action Items';
    const actionItemTextWidth = this.DOC.getTextWidth(actionItemText);
    this.DOC.text(actionItemText, this.PAGE_MIDDLE_X, this.pageY, { align: 'center' });
    this.DOC.setDrawColor(0, 0, 0);
    this.pageY = this.pageY + this.LINE_GAP_Y  ;
    this.DOC.line(this.PAGE_MIDDLE_X - actionItemTextWidth / 2, this.pageY, this.PAGE_MIDDLE_X + actionItemTextWidth / 2, this.pageY);
  }

  generateTable(table: any) {
    let tableMeta;
    let tableHeight;

    table.style.display = 'table';
    let tableRefName = '#' + table?.id;

    //this.pageY = this.pageY + 30;
    tableMeta = this.addTable(this.DOC, tableRefName, this.pageY, tableMeta);

    this.pageY = tableMeta.finalY + this.SPACER_Y;

    //this.pageY = this.pageY + 30;

    table.style.display = 'none';

  }
  addTable(doc: any, htmlRefText: any, start: any, tableMeta: any) {
    doc.autoTable({
      html: htmlRefText,
      startY: start,
      theme: 'grid',
      pageBreak: 'auto',//'avoid',
      bodyStyles: { font: 'Cairo-VariableFont_slnt,wght' },
      columnStyles: {
        0: {
          halign: 'left',
          valign: 'middle',
          fillColor: [237, 246, 255],
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          // cellWidth: 'wrap',
          cellWidth: this.HEADER_COLUMN_WIDTH

        },
        1: {
          halign: 'left',
          valign: 'middle',
          // cellWidth: 'wrap',
          cellWidth: this.DATA_COLUMN_WIDTH
        },
        2: {
          halign: 'left',
          valign: 'middle',
          fillColor: [237, 246, 255],
          textColor: [0, 0, 0],
          fontStyle: 'bold',
          cellWidth: this.HEADER_COLUMN_WIDTH,
        },
        3: {
          halign: 'left',
          valign: 'middle',
          cellWidth: this.DATA_COLUMN_WIDTH,
        },
      },
      didParseCell: (data: any) => {
        if (!tableMeta) {
          tableMeta = data.table;
        }
      },

      didDrawPage: (data: any) => {
        if (data.pageNumber > 1) {
              this.generatePageHeader();
          }
        this.generatePageFooter();
      },
      margin: { top: this.MARGIN_TOP, bottom: this.MARGIN_BOTTOM }
    });

    return tableMeta;
  }

}
